import React from 'react';

import { SVGIcon } from '../../UIKit/index';

export default function DCGrayProject(props) {
    return (
        <SVGIcon {...props} viewBox="0 0 458.74 497.75">
            <g id="Artboard_2" transform="translate(-26.61 -7.33)">
                <circle
                    id="Ellipse_9"
                    cx="227.87"
                    cy="227.87"
                    r="227.87"
                    transform="translate(28.11 8.83)"
                    fill="#fff"
                    stroke="#707171"
                    strokeMiterlimit="10"
                    strokeWidth="3"
                />
                <circle
                    id="Ellipse_10"
                    cx="11.05"
                    cy="11.05"
                    r="11.05"
                    transform="translate(45.27 205.8)"
                    fill="#fff"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <circle
                    id="Ellipse_11"
                    cx="14.78"
                    cy="14.78"
                    r="14.78"
                    transform="translate(207.26 409.96)"
                    fill="#f4f5f6"
                />
                <circle
                    id="Ellipse_12"
                    cx="7.28"
                    cy="7.28"
                    r="7.28"
                    transform="translate(232.64 425.78)"
                    fill="#e3e2e3"
                />
                <circle
                    id="Ellipse_13"
                    cx="14.78"
                    cy="14.78"
                    r="14.78"
                    transform="translate(401.88 148.4)"
                    fill="#f4f5f6"
                />
                <circle
                    id="Ellipse_14"
                    cx="7.28"
                    cy="7.28"
                    r="7.28"
                    transform="translate(427.26 164.22)"
                    fill="#e3e2e3"
                />
                <circle
                    id="Ellipse_15"
                    cx="6.44"
                    cy="6.44"
                    r="6.44"
                    transform="translate(58.9 255.65)"
                    fill="#fff"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <circle
                    id="Ellipse_16"
                    cx="6.44"
                    cy="6.44"
                    r="6.44"
                    transform="translate(65.34 151.87)"
                    fill="#fff"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <path
                    id="Path_120"
                    d="M445.43,295.6h-5.22v-5.21a.65.65,0,0,0-.65-.65h0a.66.66,0,0,0-.66.65v5.21h-5.2a.67.67,0,0,0-.66.67.66.66,0,0,0,.66.65h5.2v5.21a.66.66,0,0,0,.66.65.65.65,0,0,0,.65-.65h0v-5.21h5.22a.66.66,0,0,0,.66-.65.67.67,0,0,0-.66-.67Z"
                    fill="#e2e2e2"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="0.75"
                />
                <path
                    id="Path_121"
                    d="M460.93,258.05h-7.4v-7.39a.92.92,0,0,0-.92-.92h0a.94.94,0,0,0-.94.92v7.39h-7.38a.93.93,0,0,0,0,1.86h7.38v7.39a.93.93,0,0,0,.94.92.92.92,0,0,0,.92-.92h0v-7.39h7.4a.93.93,0,1,0,0-1.86Z"
                    fill="#e2e2e2"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="0.75"
                />
                <ellipse
                    id="_Path_"
                    cx="147.09"
                    cy="14.44"
                    rx="147.09"
                    ry="14.44"
                    transform="translate(109.3 476.2)"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_122"
                    d="M269.41,77.82a28.68,28.68,0,0,0-3.06-7.37l3.11-4.68-4.32-4.32-4.32-4.32-4.68,3.11a28.75,28.75,0,0,0-7.38-3.06l-1.1-5.51H235.44l-1.11,5.51A28.68,28.68,0,0,0,227,60.24l-4.69-3.11L218,61.45l-4.32,4.32,3.12,4.68a28.68,28.68,0,0,0-3.06,7.37l-5.51,1.11V91.15l5.51,1.11a28.829,28.829,0,0,0,3.06,7.37l-3.12,4.68,4.32,4.32,4.32,4.32,4.69-3.11a28.68,28.68,0,0,0,7.37,3.06l1.11,5.51h12.22l1.1-5.51a28.75,28.75,0,0,0,7.38-3.06l4.68,3.11,4.32-4.32,4.32-4.32-3.11-4.68a28.83,28.83,0,0,0,3.06-7.37l5.5-1.11V78.93Zm-27.86,28.62a21.41,21.41,0,1,1,15.176-6.267A21.41,21.41,0,0,1,241.55,106.44Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_123"
                    d="M226.43,161.25H137.69a8.06,8.06,0,0,1-8.05-8v-61a8.06,8.06,0,0,1,8.05-8h88.74a8.05,8.05,0,0,1,8,8v61A8.05,8.05,0,0,1,226.43,161.25ZM137.69,84.71a7.49,7.49,0,0,0-7.49,7.48v61a7.49,7.49,0,0,0,7.49,7.48h88.74a7.48,7.48,0,0,0,7.48-7.48v-61a7.48,7.48,0,0,0-7.48-7.48Z"
                    fill="#707171"
                />
                <rect
                    id="Rectangle_89"
                    width="0.82"
                    height="98.32"
                    transform="translate(154.22 125.22)"
                    fill="#707171"
                />
                <path
                    id="Path_124"
                    d="M351,327.91h-5.59V327H351Zm-11.18,0h-5.59V327h5.59Zm-11.18,0h-5.59V327h5.59Zm-11.18,0h-5.59V327h5.59Zm-11.18,0h-5.59V327h5.59Zm-11.18,0h-5.59V327h5.59Zm-11.17,0h-5.59V327h5.59Zm-11.18,0h-5.59V327h5.59Zm-11.18,0H256V327h5.59Zm-11.18,0H244.8V327h5.59Zm-11.18,0h-5.59V327h5.59Zm-11.18,0h-5.59V327H228Zm-11.18,0h-5.59V327h5.59Zm-11.18,0h-5.59V327h5.59Zm-11.18,0H188.9V327h5.59Zm162.16-.13-.14-.92a10.33,10.33,0,0,0,4.84-2.13l.58.73a11.24,11.24,0,0,1-5.28,2.32Zm-173.38-.95a11.41,11.41,0,0,1-4.41-3.71l.76-.54a10.46,10.46,0,0,0,4,3.41Zm182.12-6-.86-.35a10.428,10.428,0,0,0,.76-3.91v-1.4h.93v1.4a11.259,11.259,0,0,1-.83,4.28ZM176.85,317.7a10.686,10.686,0,0,1-.06-1.13v-4.51h.93v4.51a6.439,6.439,0,0,0,.05,1Zm189.37-8.12h-.93V304h.93Zm-188.5-3.11h-.93V300.9h.93Zm188.5-8.07h-.93v-5.59h.93Zm-188.5-3.11h-.93V289.7h.93Zm188.5-8.07h-.93v-5.59h.93Zm-188.5-3.11h-.93v-5.59h.93Zm188.5-8.07h-.93v-5.59h.93ZM177.72,273h-.93v-5.58h.93Zm188.5-8.07h-.93v-5.59h.93Zm-188.5-3.1h-.93v-5.59h.93Zm188.5-8.08h-.93v-5.59h.93Zm-188.5-3.1h-.93V245h.93Zm188.5-8.08h-.93v-5.59h.93Zm-188.5-3.1h-.93v-5.59h.93Zm188.5-8.08h-.93V225.8h.93Zm-188.5-3.1h-.93V222.7h.93Zm188.5-8.08h-.93v-5.59h.93Zm-188.5-3.1h-.93v-5.59h.93ZM366.22,209h-.93v-5.6h.93Zm-188.5-3.11h-.93V200.3h.93Zm188.5-8.07h-.93v-5.59h.93Zm-188.5-3.11h-.93v-5.59h.93Zm188.5-8.07h-.93V181h.93Zm-188.5-3.11h-.93v-5.59h.93Zm188.5-8.07h-.93v-5.59h.93Zm-188.5-3.11h-.93v-5.59h.93Zm188.5-8.07h-.93v-5.59h.93Zm-188.5-3.11h-.93v-5.59h.93Zm188.5-8.07h-.93v-5.6h.93ZM177.72,150h-.93v-5.59h.93Zm188.5-8.07h-.93v-5.59h.93Zm-188.5-3.11h-.93v-5.58h.93Zm188.5-8.07h-.93v-5.59h.93Zm-188.5-3.1h-.93V122h.93Zm188.5-8.08h-.93V114h.93Zm-188.5-3.1h-.93v-5.59h.93Zm188.5-8.08h-.93V102.8h.93Zm-188.5-3.1h-.93V99.68h.93Zm188.5-8.08h-.93V91.6a10,10,0,0,0-.21-2l.92-.18a11.869,11.869,0,0,1,.22,2.23Zm-188.5-3.1h-.93V91.6a11.089,11.089,0,0,1,.46-3.19l.89.26a10.38,10.38,0,0,0-.42,2.93Zm185-9.29a10.44,10.44,0,0,0-4.36-3l.31-.87a11.37,11.37,0,0,1,4.75,3.25Zm-181.87-.65-.65-.67a11.33,11.33,0,0,1,5-2.83l.23.9a10.42,10.42,0,0,0-4.55,2.58ZM353,81.21h-5.59v-.93H353Zm-11.17,0h-5.59v-.93h5.59Zm-11.18,0h-5.59v-.93h5.59Zm-11.18,0H313.9v-.93h5.59Zm-11.18,0H302.7v-.93h5.59Zm-11.18,0h-5.59v-.93h5.59Zm-11.18,0h-5.59v-.93H286Zm-11.18,0h-5.59v-.93h5.59Zm-11.18,0H258v-.93h5.59Zm-11.18,0H246.8v-.93h5.59Zm-11.18,0h-5.59v-.93h5.59Zm-11.18,0h-5.59v-.93h5.59Zm-11.18,0h-5.58v-.93h5.58Zm-11.17,0h-5.59v-.93h5.59Zm-11.18,0h-5.59v-.93h5.59Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_125"
                    d="M321.27,88.1s25.3,20.93,15,39.31-16.8,3.36-16.8,3.36-7.64,2.9,2.44-19.58C326.65,100.59,321.27,88.1,321.27,88.1Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_126"
                    d="M363.45,60.57s19.61,20-2.58,51.23-17.35,46.51-17.35,46.51S306.22,109.36,363.45,60.57Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_127"
                    d="M336.7,149.3c-11.12,3.06-3.53-29.88,12.69-41.05s31.28-13.2,40.08-23.48C389.47,84.77,391.46,134.21,336.7,149.3Z"
                    fill="#e3e2e3"
                />
                <rect
                    id="Rectangle_90"
                    width="188.5"
                    height="246.7"
                    rx="10.86"
                    transform="translate(165.33 99.17)"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_128"
                    d="M323.11,277.2v68.67H216.53V278a6.47,6.47,0,0,1,6.47-6.46h94.43a5.68,5.68,0,0,1,5.68,5.66Z"
                    fill="#707171"
                />
                <path
                    id="Path_129"
                    d="M115.22,252.78s4.34,2.12,3.27,7.9-1.55,6.55-.35,8.81,2.62,11.89,1.54,13.71-13.38-8-15.08-16.28,1.08-11.93,2.06-13.3S111.39,250.84,115.22,252.78Z"
                    fill="#707171"
                />
                <path
                    id="Path_130"
                    d="M136.98,245.73H123.09v12.19l2.13-2.12h11.76Z"
                    fill="#707171"
                />
                <path
                    id="Path_131"
                    d="M201.72,254.39a23.871,23.871,0,0,0,31.49-22.28v-1.6a23.866,23.866,0,1,0-31.53,23.9ZM191.5,231.58a17.87,17.87,0,0,1,34.66-5.87h0a18.07,18.07,0,0,1,1,5.12v1.2a17.868,17.868,0,1,1-35.734-.46Z"
                    fill="#fff"
                />
                <path
                    id="Path_132"
                    d="M223.49,242.75l4.72,3.65a23.87,23.87,0,0,1-26.49,8l1.92-5.65a17.92,17.92,0,0,0,19.85-6Z"
                    fill="#707171"
                />
                <path
                    id="Path_133"
                    d="M227.21,230.84l5.95-.32v1.6a23.75,23.75,0,0,1-5,14.28l-4.72-3.65A17.75,17.75,0,0,0,227.23,232C227.23,231.64,227.23,231.24,227.21,230.84Z"
                    fill="#707171"
                />
                <path
                    id="Path_134"
                    d="M227.21,230.84a18.071,18.071,0,0,0-1-5.12h0l5.61-2a24,24,0,0,1,1.39,6.85Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_135"
                    d="M195,212.78a23.83,23.83,0,0,1,36.74,10.89l-5.6,2.05h0a17.87,17.87,0,0,0-27.63-8.1Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_136"
                    d="M200.79,263.73a8.47,8.47,0,0,0-14.8,2.38h0a8.66,8.66,0,0,0-.44,2.61,8.48,8.48,0,0,0,3.29,6.81,8.34,8.34,0,0,0,4.41,1.74h1.24a8.48,8.48,0,0,0,6.31-13.57Zm-4.6,11.08h0a6.541,6.541,0,0,1-1.83.37h-.42a6.59,6.59,0,0,1-1.74-.27,6.45,6.45,0,0,1-2.07-1.06,7,7,0,0,1-.64-.57,6.33,6.33,0,0,1-1.83-4.54,7.329,7.329,0,0,1,.16-1.34,6.36,6.36,0,1,1,8.37,7.4Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_137"
                    d="M382.39,237.47s-1.2-2.1.7-7.73a5.67,5.67,0,0,1,10.24-1.46c2,3.49,1.35,5.65-1.64,9.59S383.62,239.27,382.39,237.47Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_138"
                    d="M397.2,334.38s.31,2.31.35,2.66,3.51-.21,3.51-.21l.28-2.75S397.63,334.05,397.2,334.38Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_139"
                    d="M397.51,336.75a9.68,9.68,0,0,1-2.16,2c-1.06.61-2.73.85-3.36,1.47-.46.46-1.66,2.41,2.76,2.37s6.55.28,7-.47-.68-5.53-.68-5.53a12.541,12.541,0,0,1-3.56.16Z"
                    fill="#707171"
                />
                <path
                    id="Path_140"
                    d="M373.17,334.38s.31,2.31.35,2.66,3.51-.21,3.51-.21l.28-2.75S373.6,334.05,373.17,334.38Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_141"
                    d="M373.48,336.75a9.68,9.68,0,0,1-2.16,2c-1.06.61-5,1.1-5.6,1.73-.46.46-1.21,2.28,5,2.11,4.42-.12,6.55.28,7-.47s-.68-5.53-.68-5.53a19,19,0,0,1-3.56.16Z"
                    fill="#707171"
                />
                <path
                    id="Path_142"
                    d="M396,276.78a34.208,34.208,0,0,1,1.54,10.3c-.23,4.76.92,10,1.39,15,.53,5.54,2.68,18.68,2.76,21.65s-.33,12.45-.33,12.45l-4.31.1s-3.62-23-4.56-25.31-5.59-19.05-5.74-20.93S396,276.78,396,276.78Z"
                    fill="#707171"
                />
                <path
                    id="Path_143"
                    d="M378.16,276.21s-2.62,14.62-2.93,17.53-.52,14.12-.68,15.94-1,23.85-1.87,26.56h4.8s4.94-16,4.94-23.59,3.26-16.47,5.37-21.47,6.94-5.12,8.24-14.4C396,276.78,379.91,273.26,378.16,276.21Z"
                    fill="#707171"
                />
                <path
                    id="Path_144"
                    d="M384.13,239a4.19,4.19,0,0,1,0,2.7c-.54,1.13,6.93.45,6.93.45a8.05,8.05,0,0,1,.63-4.24C392.67,236,384.13,239,384.13,239Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_145"
                    d="M396.37,278s-2.68,2.76-18.45-.43l.24-1.35,17.93.67Z"
                    fill="#606060"
                />
                <path
                    id="Path_146"
                    d="M383,242s-2.76.28-3.55.43-6.09-1-7.18-1.06-5.73-3.29-5.88-3.67-2.82-7.14-3-8.6-2.6-.71-2.39.3c.39,1.88.9,6.46,1.17,7.79s1.1,4.68,1.55,5.08a32.32,32.32,0,0,0,8.72,4.93,34.75,34.75,0,0,1,7.17,3.34H399.8s7.84-11.21,8-12.9-5.48-12.91-6.6-14.32-2.76.46-2.76.46,3.38,9.9,3.83,11.3-3.93,7.6-5.13,7.61-4.28-.37-5.65-.43a9.53,9.53,0,0,1-2.82-.65Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_147"
                    d="M374.31,249.52A6.49,6.49,0,0,1,377,254a58.819,58.819,0,0,0,1.58,8.78c.45,1.52-.39,12.56-.51,13.34s15.6,2.66,18,.79c0,0,.67-10.3,1-13.23a76.448,76.448,0,0,1,2.09-11c.45-1,5.91-8.62,6.13-9.63,0,0-2.82-4.5-4.85-4.56,0,0-3.22,3.77-4.27,3.94s-7.48-1-7.48-1-.7,1-4.43-.17c0,0-4.45.5-5.17.6-.88.11-7-.77-7-.77s-2.44,4.13-2,6.21Z"
                    fill="#707171"
                />
                <path
                    id="Path_148"
                    d="M363.56,230s-.55-2.61.11-3.36c.38-.43,1.29-1.56,1.37-1.72s1.06-.73,1.06-1-1-.6-1.78.17-1.35.93-1.68.85-.81-2.84-.85-3.53-.31-2.49-.74-2.36-.4.91-.4.91-.5-1.37-.83-1.1-.29.93-.29.93-.63-.76-.79-.2a1.86,1.86,0,0,0,0,1.05s-.64-.35-.69.52a13.229,13.229,0,0,0,.65,4.34c.45.91,2.16,3.3,2.36,4.23S363.56,230,363.56,230Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_149"
                    d="M399,225.42s-1.87-3.15-2.51-3.43a10.792,10.792,0,0,1-2.33-1c-.78-.57-1.83-1-1.77-1.22s1-.12,2,.32,1.43.22,1.52,0a5.611,5.611,0,0,0-.83-2.19c-.3-.37-2.44-2.52-2.08-2.84s1.75.86,2,1.1c0,0-1.11-2.32-.67-2.43s1.24.71,1.24.71-.1-2,2,1.24c0,0-.45-1.07.21-.72s1.29,2.37,1.5,3.38,1.14,4.24,1.94,5S399,225.42,399,225.42Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_150"
                    d="M391.69,237.87a8.51,8.51,0,0,1-3.09-.63c-2.1-.73-2.26-4.41-2.71-4a1.32,1.32,0,0,1-2.15-.25s1-1.35.55-2a5.209,5.209,0,0,0-1.25-1.13s1.48-7.12,8.2-3.87C399.12,229.82,391.69,237.87,391.69,237.87Z"
                    fill="#707171"
                />
                <path
                    id="Path_151"
                    d="M384.13,241.66l.24-1a55,55,0,0,1,6.63.26l.25,1.23a9.21,9.21,0,0,1-7.12-.49Z"
                    fill="#d4d8e8"
                />
                <path
                    id="Path_152"
                    d="M385.19,232.37c.39-.65,1.83-1.09,2,.75.13,1.42-2.58,3-2.6,1.65a4,4,0,0,1,.6-2.4Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_153"
                    d="M363.46,229.41a4.28,4.28,0,0,0-2.3.72,1.57,1.57,0,0,0,.12.77,9.389,9.389,0,0,1,2.38-.74S363.64,229.59,363.46,229.41Z"
                    fill="#707171"
                />
                <path
                    id="Path_154"
                    d="M361.63,229.8a.67.67,0,0,0,.36.87.65.65,0,0,0,.87-.35.67.67,0,0,0-1.23-.52Z"
                    fill="#606060"
                />
                <g id="Group_2" opacity="0.3">
                    <rect
                        id="Rectangle_91"
                        width="47.66"
                        height="34.98"
                        rx="4.59"
                        transform="translate(179.94 316.86)"
                        fill="#707171"
                    />
                </g>
                <g id="Group_3" opacity="0.3">
                    <rect
                        id="Rectangle_92"
                        width="47.66"
                        height="34.98"
                        rx="4.59"
                        transform="translate(290.05 316.86)"
                        fill="#707171"
                    />
                </g>
                <path
                    id="Path_155"
                    d="M279.38,193.79H190.63a8.05,8.05,0,0,1-8-8v-61a8.05,8.05,0,0,1,8-8h88.75a8.05,8.05,0,0,1,8,8v61a8.05,8.05,0,0,1-8,8Zm-88.75-76.54a7.49,7.49,0,0,0-7.48,7.48v61a7.49,7.49,0,0,0,7.48,7.48h88.75a7.49,7.49,0,0,0,7.48-7.48v-61a7.49,7.49,0,0,0-7.48-7.48Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_156"
                    d="M140.31,388.3l.58-.03-2.93-73.52h50.65l2.93,73.55.58-.03-2.95-74.1H137.35Z"
                    fill="#707171"
                />
                <path
                    id="Path_157"
                    d="M135.56,388.3l2.93-73.55h50.65l-2.92,73.52.58.03,2.95-74.13H137.93l-2.95,74.1Z"
                    fill="#707171"
                />
                <path id="Path_158" d="M186.51,364.38H135.27l2.94-73.82h51.24Z" fill="#606060" />
                <path id="Path_159" d="M142.04,364.38h51.24l-2.94-73.82H139.1Z" fill="#707171" />
                <rect
                    id="Rectangle_93"
                    width="2.58"
                    height="19.6"
                    transform="translate(182.45 335.81)"
                    fill="#fff"
                />
                <rect
                    id="Rectangle_94"
                    width="2.57"
                    height="17.4"
                    transform="translate(177.37 338)"
                    fill="#fff"
                />
                <rect
                    id="Rectangle_95"
                    width="2.57"
                    height="14.55"
                    transform="translate(171.84 340.86)"
                    fill="#fff"
                />
                <rect
                    id="Rectangle_96"
                    width="2.57"
                    height="10.94"
                    transform="translate(166.16 344.46)"
                    fill="#fff"
                />
                <path
                    id="Path_160"
                    d="M150.79,342.14l-.55-.2,4.85-13.62,10.53-2.79,3.79-14.95,8.12-3.59,1.82-11.62.59.09-1.87,11.94-8.16,3.6-3.8,15.01-10.56,2.8Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_161"
                    d="M167.09,324.77a1.581,1.581,0,1,1-2.225-.225A1.581,1.581,0,0,1,167.09,324.77Z"
                    fill="#606060"
                />
                <path
                    id="Path_162"
                    d="M167.06,327.23a1.88,1.88,0,1,1,.26-2.64A1.88,1.88,0,0,1,167.06,327.23Zm-2-2.45a1.27,1.27,0,1,0,.938-.287,1.28,1.28,0,0,0-.938.287Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_163"
                    d="M170.93,309.88a1.58,1.58,0,1,1-2.23-.22A1.58,1.58,0,0,1,170.93,309.88Z"
                    fill="#606060"
                />
                <path
                    id="Path_164"
                    d="M170.89,312.34a1.88,1.88,0,1,1,.685-1.269,1.88,1.88,0,0,1-.685,1.269Zm-2-2.45a1.29,1.29,0,1,0,.947-.288,1.29,1.29,0,0,0-.947.288Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_165"
                    d="M178.93,306.19a1.58,1.58,0,1,1-2.23-.22A1.58,1.58,0,0,1,178.93,306.19Z"
                    fill="#606060"
                />
                <path
                    id="Path_166"
                    d="M178.89,308.65a1.88,1.88,0,1,1,.27-2.64,1.88,1.88,0,0,1-.27,2.64Zm-2-2.45a1.29,1.29,0,1,0,1.81.18,1.29,1.29,0,0,0-1.81-.18Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_167"
                    d="M156.6,327.7a1.58,1.58,0,1,1-2.22-.23,1.58,1.58,0,0,1,2.22.23Z"
                    fill="#606060"
                />
                <path
                    id="Path_168"
                    d="M156.57,330.15a1.87,1.87,0,1,1,.679-1.266A1.88,1.88,0,0,1,156.57,330.15Zm-2-2.45a1.287,1.287,0,1,0,1.81.19A1.287,1.287,0,0,0,154.57,327.7Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_169"
                    d="M321.87,140.7H312a3.94,3.94,0,0,1-3.94-3.94v-9.92A3.94,3.94,0,0,1,312,122.9h9.92a4,4,0,0,1,3.94,3.94v9.92A4,4,0,0,1,321.87,140.7ZM312,123.64a3.21,3.21,0,0,0-3.21,3.2v9.92A3.21,3.21,0,0,0,312,140h9.92a3.2,3.2,0,0,0,3.2-3.2v-9.92a3.2,3.2,0,0,0-3.2-3.2Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_170"
                    d="M321.87,164.33H312a3.94,3.94,0,0,1-3.94-3.94v-9.93a3.94,3.94,0,0,1,3.94-3.94h9.92a4,4,0,0,1,3.94,3.94v9.93a4,4,0,0,1-3.99,3.94ZM312,147.26a3.21,3.21,0,0,0-3.21,3.2v9.93a3.21,3.21,0,0,0,3.21,3.2h9.92a3.21,3.21,0,0,0,3.2-3.2v-9.93a3.21,3.21,0,0,0-3.2-3.2Z"
                    fill="#e3e2e3"
                />
                <rect
                    id="Rectangle_97"
                    width="17.06"
                    height="17.06"
                    rx="3.9"
                    transform="translate(308.37 170.52)"
                    fill="#707171"
                />
                <path
                    id="Path_171"
                    d="M316.37,182.81l-4.32-3.76a.85.85,0,0,1,1.12-1.28l3.05,2.66,4.35-4.85a.85.85,0,1,1,1.27,1.13Z"
                    fill="#fff"
                />
                <rect
                    id="Rectangle_98"
                    width="15.82"
                    height="3.28"
                    rx="1.24"
                    transform="translate(145.89 309.59)"
                    fill="#e3e2e3"
                />
                <rect
                    id="Rectangle_99"
                    width="15.82"
                    height="3.28"
                    rx="1.24"
                    transform="translate(145.89 303.86)"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_172"
                    d="M117.08,375.69a11.159,11.159,0,0,0,1.27,2.12c.61.79,2.5,4,3.33,4.27s3.4.68,3.63,2.12.34,2.46-2.19,2.57-4.2.27-5.41-1.51a13.36,13.36,0,0,0-3.15-3.07v4.64h-1a41.36,41.36,0,0,0-.72-5.17c-.26-.33-.94-4,1.4-6S117.08,375.69,117.08,375.69Z"
                    fill="#606060"
                />
                <path
                    id="Path_173"
                    d="M121.68,382.08s-2.27.57-3.14,0-3.83-5.57-4.81-5.87c0,0,1-1.92,3.35-.52C117.08,375.69,121,381.25,121.68,382.08Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_174"
                    d="M143.84,296.49s1.57.3,2.11-.44a5.09,5.09,0,0,1,1.83-1.26c.43-.2,1.52-1.31,1.78-.77s-1.72,1.91-2.07,2.28,1.93.53,2.32.89-.09,4.14-1.65,3.84-3-1.63-3.31-1.63a10.385,10.385,0,0,1-1.14-.17Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_175"
                    d="M149.47,297s4.7,1.22,4.95,1.56.17.6-.28.5l-4.58-1s5.33,2.37,5.59,2.61a.351.351,0,0,1-.22.6c-.22-.03-5.66-2.08-5.66-2.08s5,2.23,5.14,2.5a.37.37,0,0,1-.47.51l-5.12-1.94s3.52,1.84,3.53,2.15-.09.62-1,.11-3.12-1.47-3.12-1.47Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_176"
                    d="M104.39,378.7a43,43,0,0,0,3.56,4.67s2.27.83,2.49,2.42.19,2.65-2.49,2.72-4.45-.4-4.94-2a7.3,7.3,0,0,0-1.57-2.73v3.4h-.61s-.15-3.29-.19-3.9-.43-2.93.85-4A3.52,3.52,0,0,1,104.39,378.7Z"
                    fill="#606060"
                />
                <path
                    id="Path_177"
                    d="M102.69,306a23.76,23.76,0,0,0-4.07,9.1c-.87,4.94.51,21.51.47,23.95s-2.31,8.51-1.85,13.11,2.24,27.48,2.24,27.48l4.91-1s-.28-23.33,0-25.26.85-9,1-9.76,7.2-21.66,7.2-25.22S110.41,300.22,102.69,306Z"
                    fill="#707171"
                />
                <path
                    id="Path_178"
                    d="M118.77,307.66s5.26,20.07,5.88,22.85,1.53,5.07,1.53,6.26a41.272,41.272,0,0,1-1,7.13l-6.68,32h-6.36s3.55-19.17,3.64-22.91,3-9.09,2.42-10.68-9.2-19.97-9.2-19.97S102.56,301.83,118.77,307.66Z"
                    fill="#707171"
                />
                <path
                    id="Path_179"
                    d="M108,383.37s-2.6,1.45-4.27-.41a13.25,13.25,0,0,1-2.19-3.67l2.9-.59Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_180"
                    d="M116.6,273.54a6.6,6.6,0,0,1,3.8,2A25.191,25.191,0,0,1,124,281c.43.93,6.44,9.61,6.75,9.8s3.34,1.21,5.34,1.88c3.1,1,9.29,3.3,9.29,3.3l-1.23,3.89s-11.65-3.81-14.57-4.53c-3.57-.88-11.78-11.42-11.78-11.42S111.68,276.74,116.6,273.54Z"
                    fill="#707171"
                />
                <path
                    id="Path_181"
                    d="M112.81,272a28.581,28.581,0,0,0,3.79,1.52c1,.2,4.76,5.12,5.42,6.91s0,4.49-1.37,7.65-.07,4.21-.7,7.37-.42,15-.31,16.74-18.25,4.41-21.88,1.21c0,0,2.45-10.65,5.36-13.69.63-.66.56-5,.13-6.13S98,284.35,98,284.35s-.36-8.27,1.75-9.91c1.84-1.42,6.83-1.93,7.73-2.24a15.44,15.44,0,0,1,5.33-.2Z"
                    fill="#707171"
                />
                <path
                    id="Path_182"
                    d="M114.15,268.78s-.08.78-.18,1.82c0,.41-.08.87-.11,1.34a33,33,0,0,0-.15,3.67s-2.92,2.93-6.24-3.41a8.7,8.7,0,0,0,.35-6.17C106.77,262.47,114.15,268.78,114.15,268.78Z"
                    fill="#e3e2e3"
                />
                <g id="Group_4" opacity="0.2">
                    <path
                        id="Path_183"
                        d="M122.32,289.26s.71-4.67,0-7.51a18.13,18.13,0,0,1-1.34,5.91Z"
                        fill="#fff"
                    />
                </g>
                <path
                    id="Path_184"
                    d="M105.23,272.65s2,5.93,7.52,5.49,2.61-5,2.61-5a12.45,12.45,0,0,0-1.76-.87c-.38-.07-6.09-.14-6.09-.14Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_185"
                    d="M115.36,273.14a54.211,54.211,0,0,1,2.89,16.12c0,8.14.23,21.4,1.24,25.59S123.37,332,123.37,332l2.25-1.16s-5.41-20.67-5.82-22.16.31-17.23.7-18.55,2-7.18,1.78-8.81c-.33-2.05-2.25-5.09-5.35-7.7Z"
                    fill="#606060"
                />
                <path
                    id="Path_186"
                    d="M106.32,272.4a83.24,83.24,0,0,1,2.7,13.1c.91,7.36-2.79,41.52-5.27,49.27l-9.62-1.55S96.2,309.08,99,304.68s3.71-8.28.67-17.45S101,273.52,101,273.52,105.48,272.49,106.32,272.4Z"
                    fill="#606060"
                />
                <path
                    id="Path_187"
                    d="M116.69,296.77l-11.66,20.19-12.96-7.48,11.15-20.49Z"
                    fill="#606060"
                />
                <path
                    id="Path_188"
                    d="M115.29,297.46l-10.36,17.93-11.51-6.64,9.91-18.19Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_189"
                    d="M111.47,295.85l.72-1.26-4.65-2.69-.91,1.16Z"
                    fill="#616161"
                />
                <path
                    id="Path_190"
                    d="M110.91,310.18a2.461,2.461,0,0,1-.76-.11s-.41-.24-.71-.39l-.23-.11a4.219,4.219,0,0,1-1.3-.55,27.721,27.721,0,0,1-2.34-2.47l.86-1.31.63-1.34a30.768,30.768,0,0,1,4.35.52l.14.09a6.18,6.18,0,0,1,.82.83c.07.06.76.74.74,1a1,1,0,0,1-.46.79,2.27,2.27,0,0,1-.49,1.15,1.39,1.39,0,0,1-.67,1S111.34,310.07,110.91,310.18Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_191"
                    d="M103,273.54a4.912,4.912,0,0,0-5.57,2.89,17.78,17.78,0,0,0-2.29,7.47c-.25,1.8-1.41,6.71-1.53,7.22s-2.73,6.55-1.53,8.67,13.46,8.38,13.38,8.84,2.12-4.72,2.12-4.72a53.6,53.6,0,0,1-5.77-3.62c-1.32-1.38-4.1-2.87-3.53-4.59.68-2,2.69-8.8,3.16-9.8S106,274.81,103,273.54Z"
                    fill="#707171"
                />
                <path
                    id="Path_192"
                    d="M114.59,253.42s6.3,2,2.88,12.86-12-1.26-11.13-7.89S114.59,253.42,114.59,253.42Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_193"
                    d="M118.11,259.77a14.24,14.24,0,0,1-8.37,3.46s-2,2.36-2.17,3.28c0,0-4.67-8,1.07-12.75S120.23,257.8,118.11,259.77Z"
                    fill="#707171"
                />
                <path
                    id="Path_194"
                    d="M109.8,263.44c0-.79-.52-2.59-1.7-2.09s.07,4.17.85,3.95C109,265.3,109.9,265.31,109.8,263.44Z"
                    fill="#e3e2e3"
                />
                <g id="Group_5" opacity="0.3">
                    <path
                        id="Path_195"
                        d="M114,270.6c0,.41-.08.87-.11,1.34,0,0-2.78-.17-4.64-4.3C109.34,267.81,111.38,270.81,114,270.6Z"
                        fill="#707171"
                    />
                </g>
                <path
                    id="Path_196"
                    d="M109.52,245.11a5.64,5.64,0,0,1-3.37-1.07,4.23,4.23,0,0,1-1.8-3.11,25.57,25.57,0,0,0-2-6.49,11.39,11.39,0,1,1,13.64-.63,24.4,24.4,0,0,0-1,6.39c.16,2.5-2.07,4.69-5,4.9Zm-.81-30.54a10.46,10.46,0,0,0-5.66,19.25,26.89,26.89,0,0,1,2.23,7h0a3.32,3.32,0,0,0,1.42,2.45,4.79,4.79,0,0,0,3.18.88c2.4-.17,4.24-1.93,4.11-3.93h0a26,26,0,0,1,1.15-6.94,10.45,10.45,0,0,0-6.43-18.7Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_197"
                    d="M107.12,241.4l-2.43-12.26,2.75,1.93,1.46-1.89,1.51,1.56,2.26-2.23-.53,12.51-.93-.04.43-10.14-1.25,1.22-1.41-1.46-1.35,1.75-1.57-1.11,1.97,9.98Z"
                    fill="#e3e2e3"
                />
                <rect
                    id="Rectangle_100"
                    width="8.08"
                    height="3.25"
                    transform="translate(105.854 244.231) rotate(-3.95)"
                    fill="#707171"
                />
                <rect
                    id="Rectangle_101"
                    width="10.67"
                    height="5.24"
                    transform="translate(104.289 241.02) rotate(-3.95)"
                    fill="#707171"
                />
                <path
                    id="Path_198"
                    d="M375.64,384.38l-13.82-42.43h44.82l13.69,42.03-1.24.4L405.7,343.26H363.62l13.26,40.72Z"
                    fill="#606060"
                />
                <path
                    id="Path_199"
                    d="M349.17,384.38l-1.24-.4,13.68-42.03h44.82l-13.81,42.43-1.24-.4,13.26-40.72H362.56Z"
                    fill="#606060"
                />
                <path id="Path_200" d="M410.32,356.08H358.11v-1.31h51.5Z" fill="#606060" />
                <rect
                    id="Rectangle_102"
                    width="61.62"
                    height="1.3"
                    transform="translate(353.3 368.94)"
                    fill="#606060"
                />
                <rect
                    id="Rectangle_103"
                    width="107.41"
                    height="105.22"
                    rx="6.01"
                    transform="translate(221.48 276.2)"
                    fill="#e3e2e3"
                />
                <rect
                    id="Rectangle_104"
                    width="81.69"
                    height="9.61"
                    rx="3.34"
                    transform="translate(243.75 208.71)"
                    fill="#707171"
                />
                <path
                    id="Path_201"
                    d="M322.1,235.53h-75a3.81,3.81,0,0,1-3.8-3.81v-2.94a3.81,3.81,0,0,1,3.8-3.8h75a3.8,3.8,0,0,1,3.8,3.8v2.94A3.81,3.81,0,0,1,322.1,235.53Zm-75-9.62a2.88,2.88,0,0,0-2.87,2.87v2.94a2.87,2.87,0,0,0,2.87,2.87h75a2.86,2.86,0,0,0,2.87-2.87v-2.94a2.87,2.87,0,0,0-2.87-2.87Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_202"
                    d="M322.1,253.55h-75a3.8,3.8,0,0,1-3.8-3.8v-2.94a3.81,3.81,0,0,1,3.8-3.8h75a3.8,3.8,0,0,1,3.8,3.8v2.94A3.8,3.8,0,0,1,322.1,253.55Zm-75-9.61a2.88,2.88,0,0,0-2.87,2.87v2.94a2.87,2.87,0,0,0,2.87,2.87h75a2.86,2.86,0,0,0,2.87-2.87v-2.94a2.87,2.87,0,0,0-2.87-2.87Z"
                    fill="#e3e2e3"
                />
                <rect
                    id="Rectangle_105"
                    width="70.35"
                    height="11.02"
                    rx="3.56"
                    transform="translate(231.23 318.86)"
                    fill="#fff"
                />
                <rect
                    id="Rectangle_106"
                    width="70.35"
                    height="11.02"
                    rx="3.56"
                    transform="translate(231.23 301.29)"
                    fill="#fff"
                />
                <rect
                    id="Rectangle_107"
                    width="15.56"
                    height="3.16"
                    rx="0.66"
                    transform="translate(232.41 367.36)"
                    fill="#fff"
                />
                <rect
                    id="Rectangle_108"
                    width="15.56"
                    height="3.16"
                    rx="0.66"
                    transform="translate(250.99 367.36)"
                    fill="#fff"
                />
                <rect
                    id="Rectangle_109"
                    width="15.56"
                    height="3.16"
                    rx="0.66"
                    transform="translate(269.82 367.36)"
                    fill="#707171"
                />
                <rect
                    id="Rectangle_110"
                    width="104.27"
                    height="76.54"
                    rx="7.76"
                    transform="translate(137.62 75.89)"
                    fill="#e3e2e3"
                />
                <rect
                    id="Rectangle_111"
                    width="48.77"
                    height="6.78"
                    rx="2.1"
                    transform="translate(182.06 86)"
                    fill="#fff"
                />
                <rect
                    id="Rectangle_112"
                    width="48.77"
                    height="7.67"
                    rx="2.1"
                    transform="translate(182.06 99.16)"
                    fill="#fff"
                />
                <path
                    id="Path_203"
                    d="M156.1,109.84a12.75,12.75,0,0,0,16.84-11.91v-.85a12.751,12.751,0,1,0-16.84,12.74Zm-5.46-12.2a9.56,9.56,0,0,1,18.54-3.14h0a9.891,9.891,0,0,1,.56,2.74c0,.21,0,.42,0,.64a9.56,9.56,0,1,1-19.11-.25Z"
                    fill="#707171"
                />
                <path
                    id="Path_204"
                    d="M167.75,103.62l2.52,1.95a12.76,12.76,0,0,1-14.17,4.27l1-3a9.58,9.58,0,0,0,10.62-3.2Z"
                    fill="#707171"
                />
                <path
                    id="Path_205"
                    d="M169.74,97.25l3.18-.17v.85a12.7,12.7,0,0,1-2.67,7.64l-2.52-1.95a9.54,9.54,0,0,0,2-5.73A4.582,4.582,0,0,0,169.74,97.25Z"
                    fill="#707171"
                />
                <path
                    id="Path_206"
                    d="M169.74,97.25a9.89,9.89,0,0,0-.56-2.74h0l3-1.09a12.8,12.8,0,0,1,.74,3.67Z"
                    fill="#707171"
                />
                <path
                    id="Path_207"
                    d="M152.53,87.58a12.75,12.75,0,0,1,19.65,5.83l-3,1.1h0a9.56,9.56,0,0,0-8.86-6.29,9.45,9.45,0,0,0-5.92,2Z"
                    fill="#707171"
                />
                <path
                    id="Path_208"
                    d="M147.45,140.63l17.14-13.32,14.87,8.07,20.77-15.73,14.88,8.41,15.71-10.69v23.26Z"
                    fill="#707171"
                />
            </g>
        </SVGIcon>
    );
}
